import { getDataBase } from '@/db';


/**
 *  .
 * 
 * @author Ing Crisitan Cuellar
 * @date 2025-03-07
 */
export default class GeneracionFacturaDAL {

    GetRecDt = async (tnGeneracionFactura) => {
        try {
            const db = await getDataBase();
            const tx = db.transaction('GENERACIONLECTURA', 'readonly');
            const store = tx.objectStore('GENERACIONLECTURA');
            const index = store.index('GeneracionFactura');
            const laClientes = await index.getAll(Number(tnGeneracionFactura));
            await tx.done;
            return laClientes;
        } catch (error) {
            console.error('Error al buscar clientes por GeneracionFactura:', error);
            return [];
        }
    } 

    


    static incrementarLecturadosZona = async (tnGeneracionFactura) => {
    try {
  
      const db = await getDataBase();
      const tx = db.transaction('GENERACIONFACTURA', 'readwrite');
      const store = tx.objectStore('GENERACIONFACTURA');
      const zona = await store.get(Number(tnGeneracionFactura));
      zona.Lecturados++;
      await store.put(zona);
      await tx.done;
    } catch (error) {
        console.log(error);
        
      throw new Error('Error al incrementar los lecturados en la zona');
    }
  };


    static getCantidadLecturas = async (generacionFactura) => {
    try {
      const db = await getDataBase();
      const tx = db.transaction('GENERACIONFACTURA', 'readonly');
      const store = tx.objectStore('GENERACIONFACTURA');
      const zona = await store.getAll(Number(generacionFactura));
      await tx.done;
  
      //traera uno se supone 
      if (zona.length == 0) {
        return {
          tnTotalLecturados: '',
          tnLecturados: '',
        };
  
      }
      const lnTotal = Number(zona[0].Lecturados) + Number(zona[0].Pendientes);
      const lnLecturados = zona[0].Lecturados;
      return {
        tnTotalLecturados: lnTotal,
        tnLecturados: lnLecturados,
      };
  
    } catch (error) {
      console.error('Error metodo getCantidadLecturas:', error);
      return {};
    }
  }



}